require("!!C:\\Software Development\\Devpark\\biz-app\\node_modules\\script-loader\\addScript.js")(require("!!C:\\Software Development\\Devpark\\biz-app\\node_modules\\raw-loader\\index.js!C:\\Software Development\\Devpark\\biz-app\\node_modules\\chart.js\\dist\\Chart.min.js"))


//////////////////
// WEBPACK FOOTER
// C:/Software Development/Devpark/biz-app/~/script-loader!C:/Software Development/Devpark/biz-app/~/chart.js/dist/Chart.min.js
// module id = ../../../../script-loader/index.js!../../../../chart.js/dist/Chart.min.js
// module chunks = 9